import React from 'react';
import {Button, CircularProgress} from 'material-ui';

const TemplateSubmit = ({
    classes,
    saveButtonLabel,
    buttonClassName,
    loading,
    onSubmit,
    onDiscard,
    onSetPreview
}) =>
    <div style={{textAlign: 'center'}}>
        <Button
            onClick={onSubmit}
            variant="raised"
            color="primary"
            className={buttonClassName}
            disabled={loading}
        >
            {saveButtonLabel}
        </Button>

        {loading && <CircularProgress size={24} className={classes.progressIcon} />}

        <Button
            variant="raised"
            color="primary"
            disabled={loading}
            onClick={() => {
                onSetPreview();
            }}
            className={classes.buttonPreview}
        >
            Preview
        </Button>

        <Button
            variant="raised"
            className={classes.discardButton}
            onClick={onDiscard}
        >
            Discard
        </Button>

    </div>;

export default TemplateSubmit;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/form/TemplateSubmit.jsx